import { render, staticRenderFns } from "./appBind.vue?vue&type=template&id=a535bf1e&scoped=true&"
import script from "./appBind.vue?vue&type=script&lang=js&"
export * from "./appBind.vue?vue&type=script&lang=js&"
import style0 from "./appBind.vue?vue&type=style&index=0&id=a535bf1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535bf1e",
  null
  
)

export default component.exports